import React from 'react';
import { Box, Divider } from '@mui/material';
import { FaPlus } from 'react-icons/fa';
import EmployeeSearch from '../../common/EmployeeSearch';
import { ReviewType, AssignmentStatus } from '../../common/filters';
import { HeaderButton } from '../../common/styles';
import { ACTIONS, SUBJECTS } from '../../../constants/permissions';

const AssignmentFilters = ({
  selectedStatuses,
  onStatusToggle,
  selectedReviewTypes,
  onReviewTypeToggle,
  selectedEmployee,
  onEmployeeChange,
  onNewAssignment,
  ability,
}) => {
  return (
    <Box sx={{
      display: 'flex',
      gap: '16px',
      flexWrap: 'wrap',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'space-between',
    }}>
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        flex: 1,
        flexWrap: 'wrap'
      }}>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          {/* Status filters */}
          <AssignmentStatus
            selectedStatuses={selectedStatuses}
            onStatusToggle={onStatusToggle}
          />
        </Box>

        {/* Vertical Divider */}
        <Divider
          orientation="vertical"
          flexItem
          sx={{
            height: '32px',
            mx: 1,
            borderColor: '#CBD5E1'
          }}
        />

        {/* Review Type Filters */}
        <ReviewType
          selectedReviewTypes={selectedReviewTypes}
          onReviewTypeToggle={onReviewTypeToggle}
        />

        {/* Vertical Divider */}
        <Divider
          orientation="vertical"
          flexItem
          sx={{
            height: '32px',
            mx: 1,
            borderColor: '#CBD5E1'
          }}
        />

        {/* Employee Filter */}
        <EmployeeSearch
          value={selectedEmployee}
          onChange={onEmployeeChange}
          includeAllOption={true}
          width={300}
          showSelectedAvatar={true}
        />
      </Box>

      {/* Schedule Individual Assignment Button */}
      {ability.can(ACTIONS.CREATE, SUBJECTS.INDIVIDUAL_ASSIGNMENT) && (
        <HeaderButton
          onClick={onNewAssignment}
          sx={{
            minWidth: 'auto',
            height: '32px',
            padding: '0 24px',
            backgroundColor: '#10b981',
            color: 'white',
            alignSelf: 'flex-start',
            '&:hover': {
              backgroundColor: '#059669',
            }
          }}
        >
          <FaPlus style={{ marginRight: '8px' }} /> Schedule Individual Assignment
        </HeaderButton>
      )}
    </Box>
  );
};

export default AssignmentFilters;
